/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const banquetCartModifierSchema = z.object({
	id: z.uuid(),
	amount: z.int(),
	size: z.uuid().nullable(),
});
